import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Dropdown } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import FormHelpButton from "./form-help-button";
import { tabPathname } from "./tab-url";
import notificationSrc from "./assets/notification.svg";
import xSrc from "./assets/x.svg";
import "./tab-menu.css";

const getInitials = (name) => {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

const TabMenu = ({ tabs, onOpenTab, onCloseTab, onCloseOtherTabs, onCloseTabsToTheRight, onCloseAllTabs }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const session = useSelector((state) => state.user.session);
  const unreadQty = useSelector((state) => state.dialogUnread?.qty) || 0;
  const pathname = location.pathname;
  const current = `${pathname}${location.search || ""}`;
  const userName = session?.name || session?.login || "Пользователь";
  const userDolj = String(session?.dolj || "").trim();

  const selectTab = (url) => {
    if (url !== current) {
      navigate(url);
    }
  };

  const openDialogs = () => {
    const tab = { title: "Диалоги", url: "/dialogs" };
    onOpenTab?.(tab);
    if (pathname !== "/dialogs") navigate("/dialogs");
  };

  return (
    <div className="tab-menu" role="tablist" aria-label="Вкладки">
      <div className="tab-menu__list">
        {tabs.length ? (
          tabs.map((tab, index) => {
            const base = tabPathname(tab.url);
            const active =
              base === pathname || (base !== "/" && pathname.startsWith(`${base}/`));
            return (
              <Dropdown
                key={base || tab.url}
                trigger={["contextMenu"]}
                menu={{
                  items: [
                    {
                      key: "closeOthers",
                      label: "Закрыть другие вкладки",
                      disabled: tabs.length <= 1
                    },
                    {
                      key: "closeRight",
                      label: "Закрыть вкладки справа",
                      disabled: index >= tabs.length - 1
                    },
                    { type: "divider" },
                    {
                      key: "closeAll",
                      label: "Закрыть все вкладки",
                      danger: true
                    }
                  ],
                  onClick: ({ key }) => {
                    if (key === "closeOthers") onCloseOtherTabs(tab.url);
                    else if (key === "closeRight") onCloseTabsToTheRight(tab.url);
                    else if (key === "closeAll") onCloseAllTabs();
                  }
                }}
              >
                <div
                  className={`tab-menu__item${active ? " tab-menu__item--active" : ""}`}
                  role="presentation"
                >
                  <button
                    type="button"
                    className="tab-menu__tab"
                    role="tab"
                    aria-selected={active}
                    onClick={() => selectTab(tab.url)}
                  >
                    <span className="tab-menu__title">{tab.title}</span>
                  </button>
                  <button
                    type="button"
                    className="tab-menu__close"
                    aria-label={`Закрыть вкладку «${tab.title}»`}
                    onClick={(e) => {
                      e.stopPropagation();
                      onCloseTab(tab.url);
                    }}
                  >
                    <img src={xSrc} alt="" />
                  </button>
                </div>
              </Dropdown>
            );
          })
        ) : (
          <span className="tab-menu__empty">Нет открытых вкладок</span>
        )}
      </div>
      <div className="tab-menu__aside">
        <FormHelpButton
          variant="native"
          className="tab-menu__help"
          icon={<QuestionCircleOutlined />}
        />
        <button
          type="button"
          className="tab-menu__notify"
          aria-label="Диалоги"
          onClick={openDialogs}
        >
          <img src={notificationSrc} alt="" />
          {unreadQty > 0 ? <span className="tab-menu__notify-dot" aria-hidden /> : null}
        </button>
        <div className="tab-menu__profile">
          <div className="tab-menu__avatar" aria-hidden>
            {getInitials(userName)}
          </div>
          <div className="tab-menu__user">
            <div className="tab-menu__name">{userName}</div>
            {userDolj ? <div className="tab-menu__role">{userDolj}</div> : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabMenu;
